<template>
    <div class="components-footer">
        <div class="container">
            <div class="footer-top">
                <div class="entrance">
                    <ul>
                        <li>常见问题</li>
                        <li>丨</li>
                        <li>关于我们</li>
                    </ul>
                </div>
                <div class="icon-item item-1">
                    服务时间：周一至周五(9:00-12:00 14:00-18:00)
                </div>
                <div class="icon-item item-2">邮箱：gsxydlxt@163.com</div>
                <div class="icon-item item-3">
                    地址：甘肃省兰州市城关区东岗西路街道农民巷8号之1号盛达金融大厦23楼
                </div>
            </div>
            <div class="footer-center">
                <div class="footer-center-left">
                    <div class="friendly-link">
                        <label>友情链接：</label>
                        <div class="span-list">
                            <span
                                v-for="(item, index) in orgList"
                                :key="index"
                                @click="orgLinkClick(item.url)"
                                >{{ item.name }}</span
                            >
                        </div>
                    </div>
                    <div class="friendly-link">
                        <label>指导单位：</label>
                        <div class="span-list">
                            <span>省发展改革委</span>
                            <span>省营商环境建设局</span>
                            <span>省委金融办</span>
                            <span>省财政厅</span>
                            <span>甘肃金融监管局</span>
                            <span>人行甘肃省分行</span>
                            <span>省大数据中心</span>
                            <span  @click="orgLinkClick('https://inf.gsei.com.cn/')">省经济研究院</span>
                        </div>
                    </div>
                    <div class="friendly-link">
                        <label>运营单位：</label>
                        <div class="span-list">
                            <span
                                @click="
                                    orgLinkClick(
                                        'https://www.gszhengxin.com.cn/portal/index'
                                    )
                                "
                                >甘肃金控集团（甘肃征信股份有限公司）</span
                            >
                        </div>
                    </div>
                    <div class="hot-wire">
                        服务热线：<b> 0931-8101279</b> <b> 0931-8101271</b>
                    </div>
                </div>
                <div class="footer-center-right">
                    <div class="weixin-code">
                        <img src="../assets/xyd/footer/icon-05.png" alt="" />
                        <p>甘肃信易贷·陇信通</p>
                    </div>
                    <div class="weixin-code">
                        <img src="../assets/xyd/footer/icon-04.png" alt="" />
                        <p>微信小程序</p>
                    </div>
                </div>
            </div>
            <div class="footer-center-bottom">备案号：陇ICP备 05000182号-6</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ComponentsFooter",
    data() {
        return {
            orgList: [
                {
                    name: "信用中国",
                    url: "https://www.creditchina.gov.cn/",
                },
                {
                    name: "全国融资信用服务平台",
                    url: "https://xyd.creditchina.gov.cn/",
                },
                {
                    name: "信用中国(甘肃)",
                    url: "https://credit.gansu.gov.cn/",
                },
                // {
                //     name: "甘肃省发展和改革委员会",
                //     url: "https://fzgg.gansu.gov.cn/",
                // },
                // {
                //     name: "甘肃省经济研究院",
                //     url: "https://inf.gsei.com.cn/",
                // },
                {
                    name: " 甘肃政务服务网",
                    url: "https://zwfw.gansu.gov.cn/index.html",
                },
                // {
                //     name: "中国经济信息社",
                //     url: "https://www.ceis.cn/",
                // },
                // {
                //     name: "新华信用",
                //     url: "https://www.credit100.com/",
                // },
                // {
                //     name: "兰州信易贷",
                //     url: "https://www.gsxyd.cn/lanzhou/index",
                // },
                {
                    name: "兰州新区绿金通",
                    url: "https://www.lzxqljt.com/",
                },
                /* {
                    name: "全国中小企业融资综合信用服务示范平台",
                    url: "https://www.celoan.cn/",
                },*/
                {
                    name: "金昌信易贷",
                    url: "http://jccredit.jcs.gov.cn/xyd/index",
                },
                {
                    name: '电e金服',
                    url: 'https://efin.sgcc.com.cn/cyl/home'
                }
            ],
        };
    },
    methods: {
        orgLinkClick(url) {
            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.components-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 280px;
    background: #e8eaef;

    .container,
    .info-item {
        // display: flex;
    }

    .container {
        height: 280px;
        align-items: center;
    }
    .footer-top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #333;
        padding: 30px 0 30px 0;
        font-size: 16px;
        .entrance {
            ul {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }
        .icon-item {
            padding-left: 20px;
            font-size: 16px;
        }
        .item-1 {
            background: url(../assets/xyd/footer/icon-01.png) no-repeat left
                center;
            background-size: 14px 14px;
        }
        .item-2 {
            background: url(../assets/xyd/footer/icon-02.png) no-repeat left
                center;
            background-size: 14px 14px;
        }
        .item-3 {
            background: url(../assets/xyd/footer/icon-03.png) no-repeat left
                center;
            background-size: 14px 14px;
        }
    }
    .footer-center {
        border-top: 1px solid #b3b3b3;
        border-bottom: 1px solid #b3b3b3;
        padding: 20px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #333;
        .footer-center-left {
            height: 117px;

            display: flex;
            flex-direction: column;
            align-content: space-between;
            justify-content: space-between;
            flex-wrap: wrap;
            flex: 1;
            .friendly-link {
                display: flex;
                flex-wrap: wrap;
                justify-content: start;
                // flex-wrap: wrap;
                // justify-content: space-between;
                line-height: 25px;
                // align-items: center;
                label {
                    width: 80px;
                    flex: 1;
                    // height: 50px;
                    // display: block;
                }
                .span-list {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    width: 1090px;
                    span {
                        padding-right: 20px;
                        display: inline-block;
                        cursor: pointer;
                    }
                }
            }
            .hot-wire {
                b {
                    font-weight: bold;
                    font-size: 24px;
                    padding-right: 10px;
                }
            }
        }

        .footer-center-right {
            width: 270px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .weixin-code {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                width: 100px;
                img {
                    width: 100px;
                    height: 100px;
                    margin: 0 auto;
                }
                p {
                    font-size: 12px;
                    padding-top: 5px;
                    text-align: center;
                    width: 100px;
                }
            }
        }
    }
    .footer-center-bottom {
        padding-top: 18px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue